import { Annotations } from 'chessboard/model/annotation/types';

/**
 * Inverts the enum to use values as keys.
 */
function invertEnum(e: any): { [key: string]: string } {
  return Object.entries(e).reduce(
    (acc, [key, value]) => {
      acc[value as any] = key;
      return acc;
    },
    {} as { [key: string]: string },
  );
}

/**
 * Get the name for a specific annotation effect.
 */
export function getAnnotationEffectName(annotation?: string): string | undefined {
  const InvertedEffects = invertEnum(Annotations.Effects);
  return annotation ? InvertedEffects[annotation] : undefined;
}
